import React from "react";
import { ErrorAlert } from "components/errorAlert/ErrorAlert";
import styled from "styled-components";

const StyledRoleList = styled.div`
  .role-list {
    list-style: disc;
    padding-left: 1.4rem;
    font: var(--body-small-600);
  }
`;

export const Error403 = ({
  title,
  description,
  isBackButton,
  requiredRole,
}: {
  title?: string;
  description?: string;
  isBackButton?: boolean;
  requiredRole?: string[];
}) => {
  return (
    <ErrorAlert
      title={title ? title : "Forbidden."}
      errorCode={403}
      buttonTitle="Go Back"
      onClick={isBackButton ? () => window.history.back() : undefined}
    >
      <StyledRoleList>
        <p>
          {description
            ? description
            : "For related inquiries, please contact syncbox@dorosee.kr."}
        </p>
        {requiredRole && (
          <ul className="role-list">
            {requiredRole.map((role) => (
              <li>{role}</li>
            ))}
          </ul>
        )}
      </StyledRoleList>
    </ErrorAlert>
  );
};
